/* eslint-disable func-names */
import Siema from 'siema';

// Default Configs
const sliderConfig = function(selector) {
  return {
    selector,
    duration: 1000,
    easing: 'cubic-bezier(0.075, 0.82, 0.165, 1)',
    loop: true,
  };
};

const incrementNavigation = function(incrementButton, slider) {
  incrementButton.addEventListener('click', () => {
    const incrementDirection = incrementButton.getAttribute('data-direction');

    if (incrementDirection === 'prev') {
      slider.prev(1);
    }

    if (incrementDirection === 'next') {
      slider.next(1);
    }
  });
};

/* Project Gallery Modal Slider */
const gallerySliderIncrementButton = Array.from(
  document.querySelectorAll('.js-gallerySliderIncrement')
);

const galleryModal = document.querySelector('.js-galleryModal');
const galleryOpen = document.querySelectorAll('.js-galleryOpen');
const galleryClose = document.querySelector('.js-galleryClose');
const html = document.querySelector('html');
const gallerySlider = new Siema(sliderConfig('.js-gallerySlider'));

galleryOpen.forEach(item => {
  item.addEventListener('click', () => {
    if (item.hasAttribute('data-index')) {
      let galleryIndex = parseInt(item.getAttribute('data-index'));
      gallerySlider.goTo(galleryIndex);
    }

    html.style.overflow = 'hidden';
    galleryModal.classList.add('-revealed');
  });
});

galleryClose.addEventListener('click', () => {
  html.style.overflow = 'visible';
  html.style.overflowX = 'hidden';
  galleryModal.classList.remove('-revealed');
});


gallerySliderIncrementButton.forEach(incrementButton => {
  incrementNavigation(incrementButton, gallerySlider);
});

/* Project Hero Slider */
const heroSliderIncrementButton = Array.from(
  document.querySelectorAll('.js-heroSliderIncrement')
);

const heroSliderNavButtons = Array.from(
  document.querySelectorAll('.js-heroSliderNavButton')
);

const heroSlider = new Siema({
  ...sliderConfig('.js-heroSlider'),
  onChange: () => {
    heroSliderNavButtons.forEach(navButton => {
      navButton.classList.remove('-active');

      const dataIndex = parseInt(navButton.getAttribute('data-index'), 0);

      if (dataIndex === heroSlider.currentSlide) {
        navButton.classList.add('-active');
      }
    });
  },
});

heroSliderIncrementButton.forEach(incrementButton => {
  incrementNavigation(incrementButton, heroSlider);
});

heroSliderNavButtons.forEach(navButton => {
  navButton.addEventListener('click', () => {
    const dataIndex = parseInt(navButton.getAttribute('data-index'));

    heroSlider.goTo(dataIndex);
  });
});
